
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40.378 40.413"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 984","fill":"#3d9ed3"}},[_c('path',{attrs:{"data-name":"Path 7102","d":"M1.427 10.2H3.69v16.568a1.412 1.412 0 001.427 1.427h5.221L3.9 38.22a1.4 1.4 0 00.418 1.949 1.491 1.491 0 00.766.209 1.4 1.4 0 001.183-.661L13.68 28.16h12.948l7.414 11.591a1.446 1.446 0 001.183.661 1.491 1.491 0 00.766-.209 1.376 1.376 0 00.418-1.949l-6.4-10.06h5.256a1.412 1.412 0 001.427-1.427V10.2h2.263a1.412 1.412 0 001.427-1.427V1.427A1.412 1.412 0 0038.951 0H1.427A1.412 1.412 0 000 1.427v7.345A1.412 1.412 0 001.427 10.2zm32.407 15.175h-6.022a1.449 1.449 0 00-.94 0H6.544V10.2h27.325v15.175zM2.785 2.854h34.7v4.49H2.819v-4.49z"}}),_c('path',{attrs:{"data-name":"Path 7103","d":"M10.756 22.591a1.453 1.453 0 001.009-.418l2.263-2.263 4.666 1.219a1.469 1.469 0 001.462-.453l4.734-5.639a1.434 1.434 0 00-2.196-1.844l-4.177 4.943-4.593-1.186a1.329 1.329 0 00-1.358.383l-2.854 2.854a1.429 1.429 0 000 2.019 1.679 1.679 0 001.044.385z"}})])])
          )
        }
      }
    